"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAME_ORIENTATIONS = void 0;
exports.GAME_ORIENTATIONS = ['PORTRAIT', 'LANDSCAPE', 'BOTH'];
